import React, { useEffect, useState } from "react";
import CardCourse from "../../components/Card/CardCourse";
import SearchBar from "../../components/Searchbar";
import { useDispatch, useSelector } from "react-redux";
import { getTeachingCourses } from "../../redux/actions/teachingCourses";
import { SideBarActiveCount } from "../Theme";

const MyCourses = () => {
  const dispatch = useDispatch();
  const courses = useSelector((state) => state.teachingCourses.courses);

  const [searchField, setSearchField] = useState("");
  const [filteredCourses, setFilteredCourses] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [searchedCourses, setSearchedCourses] = useState([]);
  const [pinnedCourses, setPinnedCourses] = useState([]);
  const [nonPinnedCourses, setNonPinnedCourses] = useState([]);

  const dropdownOption = [
    { label: "Active", value: "active" },
    { label: "All status", value: "all" },
  ];

  useEffect(() => {
    dispatch(getTeachingCourses());
  }, []);

  useEffect(() => {
    let selectedCourses = courses;
    if (selectedStatus === "active") {
      selectedCourses = selectedCourses.filter(
        (course) => course.is_archived === false
      );
    }
    if (selectedStatus === "archive") {
      selectedCourses = selectedCourses.filter(
        (course) => course.is_archived === true
      );
    }
    if (selectedStatus === "pinned") {
      selectedCourses = selectedCourses.filter(
        (course) => course.is_pinned === true
      );
    }

    // Search
    const searched = selectedCourses.filter((item) => {
      return Object.keys(item).some((key) => {
        if (item[key] !== null) {
          return item[key]
            .toString()
            .toLowerCase()
            .includes(searchField.toLowerCase());
        }
      });
    });
    setSearchedCourses(searched);
    setPinnedCourses(selectedCourses.filter((item) => item.is_pinned === true));
    setNonPinnedCourses(
      selectedCourses.filter((item) => item.is_pinned === false)
    );
  }, [courses, searchField, selectedStatus]);

  return (
    <div className="w-full backGroundColor border20pxbottom">
      <div className="flex pt-5 pb-3 px-5 items-center justify-between cardBackgroundColor flex-wrap gap-3">
        <div className="flex items-center gap-3 flex-wrap md:gap-6">
          <div>
            <SearchBar setSearchField={setSearchField} />
          </div>
          <p className="">
            Showing {pinnedCourses.length + nonPinnedCourses.length} of{" "}
            {courses.length} courses
          </p>
        </div>
        <div className="flex items-center gap-3 ">
          <input
            type="checkbox"
            className="cursor-pointer w-4 h-4 checkBoxCustom"
            checked={selectedStatus === "active"}
            onChange={() => {
              setSelectedStatus("active");
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <span className="font-normal text-base greyColor">Active</span>
          <input
            type="checkbox"
            className=" cursor-pointer w-4 h-4 checkBoxCustom"
            checked={selectedStatus === "archive"}
            onChange={() => {
              setSelectedStatus("archive");
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <span className="font-normal text-base greyColor">Archive</span>
          <input
            type="checkbox"
            className=" cursor-pointer w-4 h-4 checkBoxCustom"
            checked={selectedStatus === "pinned"}
            onChange={() => {
              setSelectedStatus("pinned");
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <span className="font-normal text-base greyColor">Pinned</span>
          <input
            type="checkbox"
            className=" cursor-pointer w-4 h-4 checkBoxCustom"
            checked={selectedStatus === "all"}
            onChange={() => {
              setSelectedStatus("all");
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <span className="font-normal text-base greyColor">All status</span>
        </div>
        {/* <div className="flex items-center">
          <select
            className=""
            type="text"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            {dropdownOption &&
              dropdownOption.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
        </div> */}
      </div>

      {/* Search result section */}
      {searchField.length > 0 && (
        <div>
          <div className="flex py-6 px-5 items-center justify-between cardBackgroundColor">
            <span className="flex items-center gap-2 md:ml-1">
              Search result
              <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                {searchedCourses.length}
              </SideBarActiveCount>
            </span>
          </div>
          <div className="grid p-2 md:p-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-2 md:gap-5">
            {searchedCourses.map((course, index) => (
              <CardCourse key={index} data={course} />
            ))}
          </div>
        </div>
      )}

      {/* Pinned courses section */}
      {pinnedCourses.length > 0 && searchField.length === 0 && (
        <div>
          <div className="flex py-6 px-5 items-center justify-between cardBackgroundColor">
            <span className="flex items-center gap-2 md:ml-1">
              Pinned
              <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                {pinnedCourses.length}
              </SideBarActiveCount>
            </span>
          </div>
          <div className="grid p-2 md:p-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-2 md:gap-5">
            {pinnedCourses.map((course, index) => (
              <CardCourse key={index} data={course} />
            ))}
          </div>
        </div>
      )}

      {/* Non Pinned courses section */}
      {nonPinnedCourses.length > 0 && searchField.length === 0 && (
        <div>
          <div className="flex py-6 px-5 items-center justify-between cardBackgroundColor">
            <span className="flex items-center gap-2 md:ml-1">
              Courses
              <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                {nonPinnedCourses.length}
              </SideBarActiveCount>
            </span>
          </div>
          <div className="grid p-2 md:p-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-2 md:gap-5">
            {nonPinnedCourses.map((course, index) => (
              <CardCourse key={index} data={course} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MyCourses;
